import {gql} from 'apollo-boost'

export const GET_NOTIFICATIONS = gql`
  query getNotifications {
    getNotifications {
      stage
      curr
      title
      msg
      icon
      summary
      action
      color
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS = gql`
  query getNotificationContracts($action: String!, $loanDetailPlanFilter: String!) {
    getNotificationContracts(
      action: $action
    ){
      id
      contractNo
      contractCloseDate
      contractName
      contractStatusName
      educationStatusName
      educationStatusExternalName
      loan {
        loanDetailPlans(filter: $loanDetailPlanFilter){
          id
          loanDetailType
          amount
        }
      }
      status
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_PRINCIPLE_BALANCE_IS_ZERO = gql`
  query getNotificationContracts($action: String!) {
    getNotificationContracts(
      action: $action
    ){
      id
      contractNo
      contractCloseDate
      contractName
      contractStatusName
      loan {
        principleRemain
      }
      status
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_IS_RULED_BUT_NOT_RESTRUCTURING = gql`
  query getNotificationContracts($action: String!) {
    getNotificationContracts(
      action: $action
    ){
      id
      contractNo
      contractName
      contractStatusName
      restructuring
      restructuringTypeName
      prosecution {
        dateOfCourtJudgment
        prosecutionResult
        prosecutionResultName
        prosecutionResultDescription
        prosecutionReasonDescription
        totalAfter
        caseStatusName
      }
      status
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_IS_RESTRUCTURING_AGING_MORE_THAN_90_DAYS = gql`
  query getNotificationContracts($action: String!) {
    getNotificationContracts(
      action: $action
    ){
      id
      contractNo
      contractName
      restructuring
      restructuringDetail {
        restructuringDate
      }
      restructuringTypeName
      loan {
        agingDate
        agingNumber
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        principleRemain
      }
      prosecution {
        caseStatusName
      }
      curriculum {
        nameTh
      }
      status
    }
  }
`

export const GET_NOTIFICATION_CURRICULUM_EXTERNALS = gql`
  query getNotificationCurriculumExternals($action: String!) {
    getNotificationCurriculumExternals(
      action: $action
    ){
      id
      periodYear
      periodTerm
      degreeName
      curriculumName
      project{
        id
        projectNo
        nameTh
      }
      curriculum{
        id
        curriculumNo
        nameTh
      }
    }
  }
`

export const GET_NOTIFICATIONS_CALL = gql`
  query getNotificationsCall {
    getNotificationsCall {
      stage
      curr
      title
      msg
      icon
      summary
      action
      color
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_CALL = gql`
  query getNotificationContractsCall($action: String!) {
    getNotificationContractsCall(
      action: $action
    ){
      id
      contractSeq
      contractNo
      contractName
      loan{
        id
        agingNumber
        payments(filters: "ntf"){
          id
          adjustment
          receiveDate
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          status
          createdAt
          createdBy{
            id
            name
            surname
            prefix{
              nameTh
            }
          }
        }
      }
      stage1CallHistories: callHistories(filters: "ntfStage1"){
        id
        seq
        callDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      stage3CallHistories: callHistories(filters: "ntfStage3"){
        id
        seq
        callDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      sendSmsHistories(filters: "ntf"){
        id
        seq
        sendDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      lawsuitHistories{
        id
        seq
        lawsuitDate
        remark
        createdAt
        createdBy{
          id
          name
          surname
          prefix{
            nameTh
          }
        }
      }
      status
    }
  }
`

export const GET_NOTIFICATIONS_CALL_EX = gql`
  query getNotificationsCallEx {
    getNotificationsCallEx {
      stage
      title
      msg
      icon
      summary
      action
      color
      userId
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_CALL_EX = gql`
  query getNotificationContractsCallEx($action: String!, $userId: String) {
    getNotificationContractsCallEx(action: $action, , userId: $userId) {
      id
      contractSeq
      contractNo
      contractName
      callHistoriesReceivedStatus
      loan {
        id
        agingNumber
        outstandingAmountRemain
        outstandingBalanceRemain
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
      }
      callHistoriesReceivedBy{
        id
        fullName
      }
      status
    }
  }
`

export const GET_NOTIFICATIONS_LAWYER = gql`
  query getNotificationsLawyer {
    getNotificationsLawyer {
      stage
      curr
      title
      msg
      icon
      summary
      action
      color
    }
  }
`

export const GET_NOTIFICATIONS_SMART_APP = gql`
  query getNotificationsSale{
    getNotificationsSale{
      stage
      curr
      title
      msg
      icon
      summary
      action
      color
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_SMART_APP = gql`
  query getNotificationContractsSale($action: String!) {
    getNotificationContractsSale(
      action: $action
    ){
      id
      contractNo
      contractDate
      contractName
      contractAmount
      smartAppStatus
      smartAppStatusName
      contractStatus
      suretyDetails {
        surety {
          idCardNumber
          prefix {
            id
            nameTh
          }
          name
          surname
        }
        seq
        relationshipId
        relationshipName
        appointmentDate
        appointmentRemark
      }
      status
    }
  }
`

export const GET_NOTIFICATION_CONTRACTS_IS_DRAFT = gql`
  query getNotificationContracts($action: String!) {
    getNotificationContracts(
      action: $action
    ){
      id
      contractNo
      contractName
      contractDate
      contractLoanDate
      loan{
        loanTypeName
      }
      status
    }
  }
`

export const REJECTED_CONTRACT_WITH_SMART_APP = gql`
  mutation rejectedContractWithSmartApp($id: ID!, $payload: SmartAppStatusTransactionInput!) {
    rejectedContractWithSmartApp(
      id: $id,
      payload: $payload
    ) {
      id
    }
  }
`

export const INSPECTIONED_CONTRACT_WITH_SMART_APP = gql`
  mutation inspectionedContractWithSmartApp($id: ID!) {
    inspectionedContractWithSmartApp(
      id: $id,
    ) {
      id
    }
  }
`

export const SUCCESS_CONTRACT_WITH_SMART_APP = gql`
  mutation successContractWithSmartApp($id: ID!) {
    successContractWithSmartApp(
      id: $id
    ) {
      id
    }
  }
`

export const CREATE_NOTIFICATIONS_FOR_SMS = gql`
  mutation CreateNotificationsForSms($contractIds: [String], $title: String!, $description: String!) {
    createNotificationsForSms(
      contractIds: $contractIds,
      title: $title,
      description: $description,
    ) {
      result
      msg
    }
  }
`
